import React, { useState, useEffect } from "react";
import { Nav } from "react-bootstrap";
import { useNavigate, useLocation } from "react-router-dom";
import { useDispatch } from 'react-redux';
import { logoutUser } from '../features/auth/authSlice';
import { bookingAPI } from '../services/api';
import { xtrafyls, logout_gif, dashboard, bookings, manage, business, logout_icon } from '../assets';
import xMarkIcon from '../assets/x-mark.svg';
import {
  FaQuestionCircle,
  FaChevronDown,
  FaChevronUp,
} from "react-icons/fa";
import termsIcon from '../assets/terms-and-conditions.svg';

export default function Sidebar({ isOpen, onClose }) {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const [manageOpen, setManageOpen] = useState(true);
  const [businessOpen, setBusinessOpen] = useState(false);
  const [showLogoutModal, setShowLogoutModal] = useState(false);
  const [newBookingsCount, setNewBookingsCount] = useState(0);

  // Fetch booking counts from API
  useEffect(() => {
    const fetchBookingCounts = async () => {
      try {
        const response = await bookingAPI.getBookingCounts();
        if (response.data?.Status === 'Success') {
          setNewBookingsCount(response.data.Data?.StatusCounts?.New || 0);
        }
      } catch (error) {
        // Error fetching booking counts
      }
    };

    fetchBookingCounts();
  }, []);

  // Handle navigation and close sidebar on mobile
  const handleNavigation = (path) => {
    navigate(path);
    if (onClose) onClose();
  };

  const handleLogoutClick = () => {
    setShowLogoutModal(true);
    document.body.style.overflow = 'hidden';
  };

  const handleCancelLogout = () => {
    setShowLogoutModal(false);
    document.body.style.overflow = 'unset';
  };

 const handleConfirmLogout = () => {
    // Clear Redux state
    dispatch(logoutUser());

    // Clear ALL localStorage items
    localStorage.clear();

    // Close modal
    setShowLogoutModal(false);
    document.body.style.overflow = 'unset';

    // Navigate to signin - BrowserRouter basename will handle the prefix
    navigate('/signin', { replace: true });
  };

  const isActive = (path) => location.pathname === path;

  return (
    <>
      {/* Mobile Overlay */}
      {isOpen && <div className="sidebar-overlay" onClick={onClose}></div>}

      <div
        className={`sidebar-container d-flex flex-column justify-content-between text-white vh-100 ${isOpen ? 'sidebar-open' : ''}`}
        style={{
          width: "250px",
          minWidth: "250px",
          flexShrink: 0,
          background: "linear-gradient(0deg, #A97EFD 0%, #5B55FF 100%)",
        }}
      >
        {/* Top Logo */}
        <div className="sidebar_top">
          <div
            className="d-flex align-items-center"
            onClick={() => handleNavigation('/dashboard')}
            style={{
              cursor: 'pointer',
              padding: '18px 24px',
              borderBottom: '0.4px solid #EEE'
            }}
          >
            <img
              src={xtrafyls}
              alt="logo"
              style={{ width: '140px' }}
            />
          </div>

          {/* Menu Items Container */}
          <div style={{ padding: '24px', display: 'flex', flexDirection: 'column', gap: '36px' }}>

          {/* Dashboard */}
          <Nav.Link
            onClick={() => handleNavigation('/dashboard')}
            className="text-white d-flex align-items-center"
            style={{
              cursor: 'pointer',
              fontFamily: 'Space Grotesk',
              fontSize: '18px',
              fontWeight: 500,
              lineHeight: '150%',
              letterSpacing: '0.36px',
              opacity: isActive('/dashboard') ? 1 : 0.7
            }}
          >
            <img src={dashboard} alt="Dashboard" className="me-2" style={{ width: '24px', height: '24px' }} />
            Dashboard
          </Nav.Link>

          {/* Bookings */}
          <Nav.Link
            onClick={() => handleNavigation('/bookings')}
            className="text-white d-flex align-items-center justify-content-between"
            style={{
              cursor: 'pointer',
              fontFamily: 'Space Grotesk',
              fontSize: '18px',
              fontWeight: 500,
              lineHeight: '150%',
              letterSpacing: '0.36px',
              opacity: isActive('/bookings') ? 1 : 0.7
            }}
          >
            <span className="d-flex align-items-center">
              <img src={bookings} alt="Bookings" className="me-2" style={{ width: '24px', height: '24px' }} />
              Bookings
            </span>
            <span className="badge bg-light text-dark">{newBookingsCount}</span>
          </Nav.Link>

          {/* Manage */}
          <div>
            <div
              onClick={() => { setManageOpen(!manageOpen); if (!manageOpen) setBusinessOpen(false); }}
              className="d-flex align-items-center justify-content-between text-white manage_text"
              style={{
                cursor: "pointer",
                fontFamily: 'Space Grotesk',
                fontSize: '18px',
                fontWeight: 500,
                lineHeight: '150%',
                letterSpacing: '0.36px'
              }}
            >
              <span className="d-flex align-items-center">
                <img src={manage} alt="Manage" className="me-2" style={{ width: '24px', height: '24px' }} /> Manage
              </span>
              {manageOpen ? <FaChevronUp size={12} /> : <FaChevronDown size={12} />}
            </div>
            {manageOpen && (
              <div className="ps-3 border-start border-light ms-2 mt-3">
                <Nav.Link
                  onClick={() => handleNavigation('/earnings')}
                  className={`py-1 ${isActive('/earnings') ? 'text-white fw-bold' : 'text-white'}`}
                  style={{
                    cursor: 'pointer',
                    fontFamily: 'DM Sans',
                    fontSize: '16px',
                    fontWeight: 400,
                    lineHeight: '150%',
                    letterSpacing: '0.32px'
                  }}
                >
                  Earnings
                </Nav.Link>
                <Nav.Link
                  onClick={() => handleNavigation('/payouts')}
                  className={`py-1 ${isActive('/payouts') ? 'text-white fw-bold' : 'text-white'}`}
                  style={{
                    cursor: 'pointer',
                    fontFamily: 'DM Sans',
                    fontSize: '16px',
                    fontWeight: 400,
                    lineHeight: '150%',
                    letterSpacing: '0.32px'
                  }}
                >
                  Payouts
                </Nav.Link>
                <Nav.Link
                  onClick={() => handleNavigation('/reviews')}
                  className={`py-1 ${isActive('/reviews') ? 'text-white fw-bold' : 'text-white'}`}
                  style={{
                    cursor: 'pointer',
                    fontFamily: 'DM Sans',
                    fontSize: '16px',
                    fontWeight: 400,
                    lineHeight: '150%',
                    letterSpacing: '0.32px'
                  }}
                >
                  Rating & Reviews
                </Nav.Link>
              </div>
            )}
          </div>

          {/* Flash Sales */}
          <Nav.Link
            onClick={() => handleNavigation('/flash-sales')}
            className="text-white d-flex align-items-center"
            style={{
              cursor: 'pointer',
              fontFamily: 'Space Grotesk',
              fontSize: '18px',
              fontWeight: 500,
              lineHeight: '150%',
              letterSpacing: '0.36px',
              opacity: isActive('/flash-sales') ? 1 : 0.7
            }}
          >
            <img src={manage} alt="Flash Sales" className="me-2" style={{ width: '24px', height: '24px' }} />
            Flash Sales
          </Nav.Link>

          {/* My Business */}
          <div>
            <div
              onClick={() => { setBusinessOpen(!businessOpen); if (!businessOpen) setManageOpen(false); }}
              className="d-flex align-items-center justify-content-between text-white business_text"
              style={{
                cursor: "pointer",
                fontFamily: 'Space Grotesk',
                fontSize: '18px',
                fontWeight: 500,
                lineHeight: '150%',
                letterSpacing: '0.36px'
              }}
            >
              <span className="d-flex align-items-center">
                <img src={business} alt="My Business" className="me-2" style={{ width: '24px', height: '24px' }} /> My Business
              </span>
              {businessOpen ? <FaChevronUp size={12} /> : <FaChevronDown size={12} />}
            </div>
            {businessOpen && (
              <div className="ps-3 border-start border-light ms-2 mt-3">
                <Nav.Link
  onClick={() => handleNavigation('/service-location')}
  className={`py-1 ${isActive('/service-location') ? 'text-white fw-bold' : 'text-white'}`}
  style={{
    cursor: 'pointer',
    fontFamily: 'DM Sans',
    fontSize: '16px',
    fontWeight: 400,
    lineHeight: '150%',
    letterSpacing: '0.32px'
  }}
>
  Service Location
</Nav.Link>
                {/* <Nav.Link
                  onClick={() => handleNavigation('/services')}
                  className={`py-1 ${isActive('/services') ? 'text-white fw-bold' : 'text-white'}`}
                  style={{
                    cursor: 'pointer',
                    fontFamily: 'DM Sans',
                    fontSize: '16px',
                    fontWeight: 400,
                    lineHeight: '150%',
                    letterSpacing: '0.32px'
                  }}
                >
                  Services
                </Nav.Link> */}
                <Nav.Link
                  onClick={() => handleNavigation('/driver')}
                  className={`py-1 ${isActive('/driver') ? 'text-white fw-bold' : 'text-white'}`}
                  style={{
                    cursor: 'pointer',
                    fontFamily: 'DM Sans',
                    fontSize: '16px',
                    fontWeight: 400,
                    lineHeight: '150%',
                    letterSpacing: '0.32px'
                  }}
                >
                  Drivers/Team
                </Nav.Link>
                <Nav.Link
                  onClick={() => handleNavigation('/availability')}
                  className={`py-1 ${isActive('/availability') ? 'text-white fw-bold' : 'text-white'}`}
                  style={{
                    cursor: 'pointer',
                    fontFamily: 'DM Sans',
                    fontSize: '16px',
                    fontWeight: 400,
                    lineHeight: '150%',
                    letterSpacing: '0.32px'
                  }}
                >
                  Availability
                </Nav.Link>
                <Nav.Link
                  onClick={() => handleNavigation('/profile')}
                  className={`py-1 ${isActive('/profile') ? 'text-white fw-bold' : 'text-white'}`}
                  style={{
                    cursor: 'pointer',
                    fontFamily: 'DM Sans',
                    fontSize: '16px',
                    fontWeight: 400,
                    lineHeight: '150%',
                    letterSpacing: '0.32px'
                  }}
                >
                  Business Profile
                </Nav.Link>
                {/* <Nav.Link
                  onClick={() => handleNavigation('/service-area')}
                  className={`py-1 ${isActive('/service-area') ? 'text-white fw-bold' : 'text-white'}`}
                  style={{
                    cursor: 'pointer',
                    fontFamily: 'DM Sans',
                    fontSize: '16px',
                    fontWeight: 400,
                    lineHeight: '150%',
                    letterSpacing: '0.32px'
                  }}
                >
                  Service Area
                </Nav.Link> */}
              </div>
            )}
          </div>

          {/* Support */}
          <Nav.Link
            onClick={() => handleNavigation('/support')}
            className="text-white d-flex align-items-center"
            style={{
              cursor: 'pointer',
              fontFamily: 'Space Grotesk',
              fontSize: '18px',
              fontWeight: 500,
              lineHeight: '150%',
              letterSpacing: '0.36px',
              opacity: isActive('/support') ? 1 : 0.7
            }}
          >
            <FaQuestionCircle className="me-2" style={{ width: '24px', height: '24px' }} /> Support
          </Nav.Link>

          {/* Terms & Policies */}
          <Nav.Link
            onClick={() => handleNavigation('/terms-policies')}
            className="text-white d-flex align-items-center"
            style={{
              cursor: 'pointer',
              fontFamily: 'Space Grotesk',
              fontSize: '18px',
              fontWeight: 500,
              lineHeight: '150%',
              letterSpacing: '0.36px',
              opacity: isActive('/terms-policies') ? 1 : 0.7
            }}
          >
            <img src={termsIcon} alt="Terms & Policies" className="me-2" style={{ width: '24px', height: '24px' }} /> Terms & Policies
          </Nav.Link>
          </div>
        </div>

        {/* Bottom Logout */}
        <div style={{
          padding: '20px 24px',
          borderTop: '0.4px solid #EEE'
        }}>
          <Nav.Link
            onClick={handleLogoutClick}
            className="text-white d-flex align-items-center"
            style={{
              cursor: 'pointer',
              fontFamily: 'Space Grotesk',
              fontSize: '18px',
              fontWeight: 500,
              lineHeight: '150%',
              letterSpacing: '0.36px'
            }}
          >
            <img src={logout_icon} alt="Logout" className="me-2" style={{ width: '24px', height: '24px' }} />Logout
          </Nav.Link>
        </div>
      </div>

      {/* Logout Confirmation Modal */}
      {showLogoutModal && (
        <div className="logout-modal-overlay" onClick={handleCancelLogout}>
          <div className="logout-modal" onClick={(e) => e.stopPropagation()}>
            
            {/* Close Button */}
            <button className="logout-modal-close" onClick={handleCancelLogout}>
              <img src={xMarkIcon} alt="Close" />
            </button>

            {/* Modal Header */}
            <h3 className="logout-modal-title">Logout</h3>

            {/* Icon */}
            <div className="logout-icon-wrapper">
              <img src={logout_gif} alt="Logout" style={{ width: '120px', height: '120px' }} />
            </div>

            {/* Question */}
            <h4 className="logout-question">Are you sure you want to logout?</h4>

            {/* Description */}
            <p className="logout-description">Confirm to sign out from your account.</p>

            {/* Buttons */}
            <div className="logout-modal-buttons">
              <button className="logout-cancel-btn" onClick={handleCancelLogout}>
                Cancel
              </button>
              <button className="logout-confirm-btn" onClick={handleConfirmLogout}>
                Logout
              </button>
            </div>

          </div>
        </div>
      )}
    </>
  );
}